import { axiosPrivate } from "../api/axios";
import useAuth from "./useAuth";

const useLogout = () => {
  const { handleLogout } = useAuth();

  const logout = async () => {
    try {
      await axiosPrivate.post('/api/logout');
      handleLogout();
    } catch (err) {
      console.error(err.message);
    }
  }

  return logout;
}

export default useLogout